import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Value = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const type = useWatch({ control, name: `suspiciousActivityInfo.cyberEventIndicators.${index as 0}.type` })
  const hasType = !!type

  return (
    <Controller
      name={`suspiciousActivityInfo.cyberEventIndicators.${index as 0}.value`}
      control={control}
      rules={{ validate: (value) => (hasType ? Validators.required.field(value) : undefined) }}
      render={({ field }) => (
        <FF2
          required={hasType}
          label="Event Value"
          field={field}
          input={(props) => <TextInput {...props} disabled={!hasType} />}
        />
      )}
    />
  )
}
